import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import {
  Sheet,
  SheetContent,
} from '@/components/ui/sheet';
import { useReducedMotion } from '@/hooks/useReducedMotion';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  navLinks: Array<{ label: string; path: string }>;
}

export function MobileMenu({ isOpen, onClose, navLinks }: MobileMenuProps) {
  const location = useLocation();
  const prefersReducedMotion = useReducedMotion();

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="left" className="w-[300px] sm:w-[400px]">
        <nav className="flex flex-col gap-2 mt-6">
          {navLinks.map((link, index) => (
            <motion.div
              key={link.path}
              initial={prefersReducedMotion ? { opacity: 1 } : { x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={
                prefersReducedMotion
                  ? { duration: 0.1 }
                  : {
                      delay: index * 0.1,
                      type: 'spring',
                      stiffness: 300,
                      damping: 24,
                    }
              }
            >
              <Link
                to={link.path}
                onClick={onClose}
                className={`flex items-center px-4 py-3 text-xl font-medium rounded-lg transition-colors ${
                  location.pathname === link.path
                    ? 'bg-[#0000FF] text-white'
                    : 'hover:bg-accent'
                }`}
              >
                {link.label}
              </Link>
            </motion.div>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
}

